import { render } from "./ProductTableSize.vue?vue&type=template&id=19ce8b17"
import script from "./ProductTableSize.vue?vue&type=script&lang=js"
export * from "./ProductTableSize.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__